<div class="donut container" #container>
    <svg [attr.width]="dimensions.width" [attr.height]="dimensions.height"></svg>
</div>
